module.exports = __webpack_public_path__ + "img/formats-6.374a77ff.png";